import React from 'react';
import Icon from '../../../components/AppIcon';

const TrustSignals = () => {
  const trustSignals = [
    {
      icon: 'ShieldCheck',
      label: 'SSL Secured',
    },
    {
      icon: 'Lock',
      label: 'Privacy Protected',
    },
    {
      icon: 'CheckCircle',
      label: 'Verified Access',
    },
  ];

  return (
    <div className="w-full max-w-full overflow-hidden">
      <div className="w-full grid grid-cols-1 gap-2 sm:grid-cols-3">
        {trustSignals?.map((signal) => (
          <div
            key={signal?.label}
            className="w-full min-w-0 max-w-full overflow-hidden rounded-lg border border-border bg-muted/30 px-2 py-2"
          >
            <div className="flex w-full min-w-0 items-center justify-center gap-1.5 overflow-hidden">
              <Icon
                name={signal?.icon}
                size={14}
                className="shrink-0 text-primary"
              />

              <span className="block min-w-0 max-w-full truncate text-center text-[10px] font-medium leading-tight text-muted-foreground">
                {signal?.label}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrustSignals;